import { addToGlobalThisRet } from "@plugins";

function setTestResultWidth() {
    const wraps = document.querySelectorAll(".js-user-results-wrap");

    if (wraps) {
        wraps.forEach((wrap) => {
            const score = wrap.querySelector(".js-user-score");
            const fillTarget = wrap.querySelector(".js-fill-user-result");

            if (score && fillTarget) {
                fillTarget.style.width = `${score.innerHTML}`;
            }
        });
    }
}

window.addEventListener("load", () => {
    setTestResultWidth();
});

addToGlobalThisRet(setTestResultWidth, "setTestResultWidth");
